import L from "leaflet/dist/leaflet.js";

const Map = {
  current: null,
  defaultZoom: 4.8,
  defaultView: [62.18931228125963, 15.627884095017937], // sweden
  //defaultView: [55.38477446067146, 13.160942855475351], // IFK Trelleborg FK
  isSinglePost: false,
  cardWrapper: null,
  cards: [],
  markerGroup: null,
  markers: [],

  init: () => {
    // check if map is present
    const hasMap = document.getElementById("map");
    if (!hasMap) return;

    // check for card wrapper
    Map.cardWrapper = document.getElementById("results");

    if (!Map.cardWrapper) {
      // check if single post
      Map.cardWrapper = document.querySelector("body.single");
      if (Map.cardWrapper) Map.isSinglePost = true;
    }

    Map.create();

    // only add pins if we have a card wrapper...
    if (Map.cardWrapper) {
      Map.addPins();
    }
  },

  create: () => {
    console.log("Creating map...");

    // create new map with default settings
    Map.current = L.map("map", {
      center: Map.defaultView,
      zoom: Map.defaultZoom,
      scrollWheelZoom: false,
      minZoom: 4,
    });

    // setup map click handler
    Map.current.on("click", Map.handleClick);

    // setup map zoom end event handler
    Map.current.on("zoomend", function () {
      console.log(Map.current.getZoom());
    });

    // Important! Do not remove the copyright disclaimer!
    // add copyright disclaimer
    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> contributors',
    }).addTo(Map.current);
  },

  zoomToLocation: (latLng) => {
    console.log("zooming to location...");

    setTimeout(function () {
      Map.current.setView(latLng, 14);
    }, 1000);
  },

  findCards: () => {
    console.log("finding cards...");
    let cards = [];

    if (Map.cardWrapper) {
      cards = Array.from(Map.cardWrapper.querySelectorAll(".club-pin"));
    }

    return cards;
  },

  addPins: () => {
    console.log("adding pins...");

    // find cards
    Map.cards = Map.findCards();

    console.log(`found: ${Map.cards.length} card(s)`);

    if (Map.cards.length != -1 && Map.cards.length != 0) {
      Map.cards.forEach((card) => {
        const latitude = card.dataset.latitude;
        const longitude = card.dataset.longitude;
        const title = card.dataset.title;

        // get address wrapper from card
        const addressWrapper = card.querySelector(".club-meta__address");
        const addressFull = addressWrapper ? addressWrapper.innerHTML : "";

        // trim address
        let address = addressFull.replace("<b>Adress</b><br>", "");
        address = address.replace(title, `<b>${title}</b>`);
        address = !address ? `<b>${title}</b>` : `<b>${title}</b>${address}`;

        if (latitude && longitude) {
          console.log(
            `adding ${title} pin to location: ${[latitude, longitude]}`,
          );

          // add marker to array
          Map.markers.push(
            L.marker([latitude, longitude]).bindPopup(`${address}`),
          );
        }
      });

      if (Map.markers.length != -1 && Map.markers.length != 0) {
        // create layer group w/ markers and add it to the map!
        Map.markerGroup = L.featureGroup(Map.markers).addTo(Map.current);

        // get bounds based on current pins showing
        const bounds = Map.markerGroup.getBounds();

        if (bounds) {
          // zoom map to current bounds
          Map.current.fitBounds(bounds, {
            padding: [40, 40],
          });

          // single pin
          if (Map.markers.length == 1) {
            // zoom out
            Map.current.setZoom(10);

            // zoom in after a while
            setTimeout(function () {
              Map.current.setZoom(14);
            }, 1000);
          }
        }
      }
    }
  },

  removePins: () => {
    if (Map.markerGroup) {
      // clear all marker layers from marker group
      Map.markerGroup.clearLayers();
    }

    // clear all markers
    Map.markers = [];

    // clear all cards
    Map.cards = [];
  },

  handleClick: (e) => {
    console.log("--------------------");

    console.log(`latlng: ${e.latlng}`);
    console.log(`lat: ${e.latlng.lat}`);
    console.log(`lng: ${e.latlng.lng}`);

    // add popup at lat/lng
    // L.popup()
    //   .setLatLng(e.latlng)
    //   .setContent(
    //     `<b>Latitude / Longitude</b> <br>${e.latlng.toString()}<br>Lat: ${e.latlng.lat.toString()}<br>Lng: ${e.latlng.lng.toString()}`
    //   )
    //   .openOn(Map.current);
  },
};

export default Map;
